import axios from 'axios';
import type { } from '../types';

const api = axios.create({ baseURL: import.meta.env.VITE_API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface Company { id: string; name: string; type: 'shipper'|'receiver'; createdAt?: string; updatedAt?: string; }

export const listCompanies = async (): Promise<Company[]> => {
  const { data } = await api.get('/api/companies');
  return data;
};

export const createCompany = async (payload: Omit<Company, 'id'>): Promise<Company> => {
  const { data } = await api.post('/api/companies', payload);
  return data;
};

export const updateCompany = async (id: string, payload: Partial<Company>): Promise<Company> => {
  const { data } = await api.patch(`/api/companies/${id}`, payload);
  return data;
};

export const deleteCompany = async (id: string): Promise<void> => {
  await api.delete(`/api/companies/${id}`);
};
